export { default as DetailSectionEditable } from './ui/editable/DetailSection.editable';
export { default as DetailSectionPublic } from './ui/public/DetailSection.public';